module.exports = __webpack_public_path__ + "static/media/logo-orange-blue.a1145539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/logo-orange-blue.jpg
// module id = 1249
// module chunks = 157